export default "__VITE_ASSET__DGwIC$Oc__"